import { Center, Spinner } from '@frontend/legacy-components';

const AnalyticsSplashPage = () => {
  return (
    <Center>
      <Spinner size="xl" />
    </Center>
  );
};

export default AnalyticsSplashPage;
